module.exports = __webpack_public_path__ + "static/media/UneteEquipo.039d31d1.svg";